import { render, staticRenderFns } from "./VehicleExcessUnder25.vue?vue&type=template&id=1fe20b68&"
import script from "./VehicleExcessUnder25.vue?vue&type=script&lang=js&"
export * from "./VehicleExcessUnder25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports